// components/icons/ServerHostingIcon.jsx
import React from 'react';

export default function ServerHostingIcon({ className = '' }) {
  return (
    <div className={`serverGroup w-12 h-12 ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 41"
        fill="none"
        className="w-full h-full"
      >
        {/* 상단 서버 박스 */}
        <path
          className="server-box top"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.0841 10.5149H3.97742V20.2134H37.0841V10.5149Z"
          fill="#1581FC"
        />
        {/* 상단 라인 */}
        <path
          className="server-line top-line"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.0841 12.5149H20.3589V14.5149H35.0841V12.5149Z"
          fill="#F8FBFF"
        />

        {/* 하단 서버 박스 */}
        <path
          className="server-box bottom"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.0841 20.2134H3.97742V29.9119H37.0841V20.2134Z"
          fill="#131313"
        />
        {/* 하단 라인 */}
        <path
          className="server-line bottom-line"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.0841 22.2134H20.3589V24.2134H35.0841V22.2134Z"
          fill="#F8FBFF"
        />
      </svg>
    </div>
  );
}
